import { DecimalUtils } from "../decimal/DecimalUtils";
import { DISPLAY_SCALE } from "../decimal/scales";
import { getNumericValue, type NumericInput } from "./formatterUtils";

type NumberFormatterOptions = {
  scale?: number;
};

const formatterCache = new Map<string, Intl.NumberFormat>();

export function formatWithThousandsSeparator(value: NumericInput, options: NumberFormatterOptions = {}): string {
  const { scale = DISPLAY_SCALE } = options;
  const numericValue = getNumericValue(value) ?? 0;
  const displayValue = DecimalUtils.toNumber(numericValue, { scale });

  const formatterKey = `${scale}`;

  const existingFormatter = formatterCache.get(formatterKey);

  if (existingFormatter) return existingFormatter.format(displayValue);

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: scale,
    maximumFractionDigits: scale,
  });

  formatterCache.set(formatterKey, formatter);

  return formatter.format(displayValue);
}
